// extracted by mini-css-extract-plugin
export default {"analysis":"ScreeningAnalysis_analysis__jYRR1"};